var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chre-box"},[_vm._v("\n    产品中心\n")])}
var staticRenderFns = []

export { render, staticRenderFns }